import React, { useState } from "react";
import { Link } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";
import UserSideBar from "./Components/Sidebar";
import {
    Search1Icon,
    UserAppointmentImg1,
    UserAppointmentImg2,
    UserAppointmentImg3,
} from "../../Constant/Index";
const TherapistAppointments = () => {
    const Appointments = [
        {
            Name: "John Merchant",
            Service: "Child Psychotherapy ",
            Date: "12, Dec,2023",
            Time: "4:30 PM",
            Image: UserAppointmentImg1
        },
        {
            Name: "John Merchant",
            Service: "Child Psychotherapy ",
            Date: "12, Dec,2023",
            Time: "4:30 PM",
            Image: UserAppointmentImg2
        },
        {
            Name: "John Merchant",
            Service: "Child Psychotherapy ",
            Date: "12, Dec,2023",
            Time: "4:30 PM",
            Image: UserAppointmentImg3
        }
    ];
    return (
        <>
            <Header />
            <UniversalBanner heading="My Profile" />
            <section className="profile-main">
                <div className="container">
                    <div className="profile-start">
                        <div className="row">
                            <UserSideBar />
                            <div className="col-lg-9 col-md-8">
                                <div className="profile-box">
                                    <div className="top-heading d-flex gap-4 align-items-center pb-4">
                                        <h3 className="md-heading min-width-fit mb-0">My Bookings</h3>
                                        <hr className="w-100" />
                                    </div>
                                    <div className="form-area">
                                        <div className="form-group password">
                                            <input type="text" name="" className="form-control border-0" placeholder="Search" id="" />
                                            <button className="show-password bg-transparent" type="button">
                                                <img src={Search1Icon} className="eye-icon" alt="" />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="appointment-list">
                                        {
                                            Appointments.map((SingleAppointment, index) => (
                                                <Link to="/therapist/booking/1">
                                                    <div className="single-appointment">
                                                        <div className="about-appointment">
                                                            <figure className="appointment-img">
                                                                <img src={SingleAppointment.Image} alt={SingleAppointment.Name} className="img-fluid img-here" />
                                                            </figure>
                                                            <div className="appointment-data">
                                                                <span className="name">{SingleAppointment.Name}</span>
                                                                <span className="service">Service  <span className="service-name ps-2">{SingleAppointment.Service}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="time-date">
                                                            <div className="appointment-time">
                                                                <span className="date-svg">
                                                                    <svg width="15" height="16" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M11.75 2.66634V0.833008M11.75 2.66634V4.49967M11.75 2.66634H7.625M0.75 8.16634V16.4163C0.75 16.9026 0.943154 17.3689 1.28697 17.7127C1.63079 18.0565 2.0971 18.2497 2.58333 18.2497H15.4167C15.9029 18.2497 16.3692 18.0565 16.713 17.7127C17.0568 17.3689 17.25 16.9026 17.25 16.4163V8.16634M0.75 8.16634H17.25M0.75 8.16634V4.49967C0.75 4.01344 0.943154 3.54713 1.28697 3.20331C1.63079 2.8595 2.0971 2.66634 2.58333 2.66634H4.41667M17.25 8.16634V4.49967C17.25 4.01344 17.0568 3.54713 16.713 3.20331C16.3692 2.8595 15.9029 2.66634 15.4167 2.66634H14.9583M4.41667 0.833008V4.49967" stroke="#01323B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                </span>
                                                                <span className="text">{SingleAppointment.Date}</span>
                                                            </div>
                                                            <div className="appointment-date">
                                                                <span className="time-svg">
                                                                    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M10 4.59961V9.99961H15.4" stroke="#01323B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M10 19C14.9707 19 19 14.9707 19 10C19 5.0293 14.9707 1 10 1C5.0293 1 1 5.0293 1 10C1 14.9707 5.0293 19 10 19Z" stroke="#01323B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                </span>
                                                                <span className="text">{SingleAppointment.Time}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            ))
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Newsletter />
            <Footer />
        </>
    )
}
export default TherapistAppointments;